import { render, staticRenderFns } from "./TransportationServices.vue?vue&type=template&id=463bd78a&"
import script from "./TransportationServices.vue?vue&type=script&lang=js&"
export * from "./TransportationServices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports